export default __webpack_public_path__ + "static/media/contributor-filter-modal-logo.7341b46a.svg";